import { render, staticRenderFns } from "./task-duty-pannel.vue?vue&type=template&id=3ccd555c&scoped=true&"
import script from "./task-duty-pannel.vue?vue&type=script&lang=js&"
export * from "./task-duty-pannel.vue?vue&type=script&lang=js&"
import style0 from "./task-duty-pannel.vue?vue&type=style&index=0&id=3ccd555c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd555c",
  null
  
)

export default component.exports